<template>
  <ticket-submit-dialog :get-ticket-create-data="ticketData" :ticket-available="ticketAvailable" :closeDialog="cancelDialog">
    <a-list item-layout="horizontal" :data-source="params.errors || []">
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a-descriptions bordered :column="1" :key="'desc'+index">
          <a-descriptions-item :label="$t('scope.error.location')" v-if="item.meta">
            {{ item.meta.componentName || '-' }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('scope.text_433')">
            {{ item.error }}
          </a-descriptions-item>
        </a-descriptions>
      </a-list-item>
    </a-list>
  </ticket-submit-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import TicketSubmitDialog from './TicketSubmit'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

// 异常处理
export default {
  name: 'ExceptionDialog',
  components: { TicketSubmitDialog },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
    ticketAvailable () {
      return this.$store.state.auth.canRenderDefaultLayout
    },
  },
  methods: {
    ticketData () {
      let comment = ''
      if (this.params.errors) {
        const es = this.params.errors.map(e => {
          return `location: ${e.meta ? e.meta.componentName : '-'}\nstack: ${e.error.stack || e.error.message}`
        })

        comment = es.join('\n\n------------------\n\n')
      } else {
        comment = JSON.stringify(this.params)
      }
      return {
        variables: {
          process_definition_key: 'customer-service',
          priority: 'critical',
          initiator: this.userInfo.id,
          comment: comment,
        },
      }
    },
  },
}
</script>

<style scoped>

</style>
